import { generateAPI } from "../api.generator";

export interface NotificationStatusResponse {
  unreadCount: number;
}

export const getNotificationStatus = generateAPI<
  Record<string, unknown>,
  NotificationStatusResponse
>("get", "notifications/status");
